import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import ExclamationCircle from 'dibs-icons/exports/legacy/ExclamationCircle';
import { Link } from 'dibs-elements/exports/Link';

import { getLongChainName } from '../supportedChains';

import styles from './EthereumError.scss';

export const EthereumUnsupportedChainError: FC<{
    isMetaMaskInstalled: boolean;
    switchMetaMaskEthereumChain: () => Promise<void>;
}> = ({ isMetaMaskInstalled, switchMetaMaskEthereumChain }) => {
    const networkName = getLongChainName();
    const bodyCopy = isMetaMaskInstalled ? (
        <FormattedMessage
            id="ethereum.unsupportedChainError.bodyCopyMetaMask"
            defaultMessage="<a>Please switch to {networkName} in order to proceed</a>."
            values={{
                networkName,
                a: text => (
                    <Link onClick={switchMetaMaskEthereumChain} key="switchMetaMaskEthereumChain">
                        {text}
                    </Link>
                ),
            }}
        />
    ) : (
        <FormattedMessage
            id="ethereum.unsupportedChainError.bodyCopyWalletConnect"
            defaultMessage="Please connect to {networkName} in order to proceed."
            values={{ networkName }}
        />
    );
    return (
        <div className={styles.container}>
            <div className={styles.alertBox}>
                <ExclamationCircle className={styles.exclamationIcon} />
                <p>
                    <FormattedMessage
                        id="ethereum.unsupportedChainError.copy1"
                        defaultMessage="You are connected to an unsupported network."
                    />
                </p>
            </div>
            <p>{bodyCopy}</p>
        </div>
    );
};
